import { FunctionComponent } from 'react';
import { Box, Card, CardBody, Flex, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import { BusinessLineGroup, ClientSummary } from '@/types/applications';

const ClientTile: FunctionComponent<{
  client: ClientSummary;
  onSelect: () => void;
}> = ({ client, onSelect }) => (
  <Card
    cursor="pointer"
    border="1px solid"
    borderColor="marketcast.gray.5"
    borderRadius="12px"
    boxShadow="sm"
    transition="all 0.2s"
    _hover={{
      boxShadow: 'md',
      borderColor: 'marketcast.primaryCta.1',
      transform: 'translateY(-2px)',
    }}
    onClick={onSelect}
  >
    <CardBody p={0}>
      <Flex direction="column" align="center" justify="center" py={6} px={3} minH="100px">
        <Text
          fontSize="sm"
          fontWeight="500"
          color="marketcast.text.primary"
          textAlign="center"
          lineHeight="1.3"
          noOfLines={2}
        >
          {client.groupName}
        </Text>
      </Flex>
    </CardBody>
  </Card>
);

const BusinessLineSection: FunctionComponent<{
  group: BusinessLineGroup;
  onClientSelect: (client: ClientSummary) => void;
}> = ({ group, onClientSelect }) => (
  <Box mb={8}>
    <Flex align="center" gap={3} mb={4}>
      <Box>
        <Heading size="sm" color="marketcast.text.primary">
          {group.businessLine}
        </Heading>
        <Text fontSize="xs" color="marketcast.gray.2">
          {group.clients.length} {group.clients.length === 1 ? 'client' : 'clients'}
        </Text>
      </Box>
    </Flex>

    <SimpleGrid columns={{ base: 2, sm: 3, md: 4, lg: 5 }} spacing={4}>
      {group.clients.map((client) => (
        <ClientTile key={client.groupId} client={client} onSelect={() => onClientSelect(client)} />
      ))}
    </SimpleGrid>
  </Box>
);

export default BusinessLineSection;
